import { useContext, useState, useMemo, useCallback } from "react";
import { TenantContext } from "../../../../templates/context/TenantContext";
import { i18n } from "../../../../translate/i18n";
import {
  Carousel,
  ProductAnalysisChart,
  NewTableOptions
} from "../../../../components/SharedComponents/sharedComponents.index";
import { CustomText, CustomHeading } from "../../../../components/StyledComponents/styleComponents.index";
import { PredictionsTable } from "./index";
import PropTypes from 'prop-types';

export function ProductView({ actions, ctx, uiState }) {

  const { t } = i18n;

  const { setSelectedProductIds, setFreezeColumns } = actions || {};

  const { productIds, selectedProductIds, generationDate, products } = ctx || {};

  const { freezeColumns } = uiState || {};

  const { hierarchy } = useContext(TenantContext);

  const [checkedProducts, setCheckedProducts] = useState([]);
  const [selectedHierarchyIndexes, setSelectedHierarchyIndexes] = useState(
    hierarchy.levels.map((level, index) => index)
  );
  
  const carouselCtx = useMemo(
    () => ({ checkedProducts: checkedProducts, products: products }),
    [checkedProducts, products]
  );

  const renderGraphicAnalysis = useCallback(() => (
    <ProductView.ChartCarouselToDisplayItensInfo ctx={carouselCtx} />
  ), [carouselCtx]);

  const subtitles = [`${t("forecastGeneratedIn")} ${generationDate}`]

  return (
    <div style={{ display: "flex", flexDirection: "column", inlineSize: "100%" }}>

      <div
        style={{ marginBlockEnd: "1rem"}}>
        <CustomHeading fontWeight={600} color="black" fontSize={['0.3rem', '0.9rem', '1.5rem']} margin="2rem 0 0 0">
          {t("productView")}
        </CustomHeading>

        {subtitles?.length && (
          subtitles.map((subtitle) => (
            <CustomText margin="0 0" size="xs" key={subtitle}>
              {subtitle}
            </CustomText>
          ))
        )}
      </div>

      <NewTableOptions
        actions={{
          checkedProducts: checkedProducts,
          renderGraphicAnalysis: renderGraphicAnalysis,
          setFreezeColumns: setFreezeColumns,
          setSelectedProductIds: setSelectedProductIds,
          setSelectedHierarchyIndexes: setSelectedHierarchyIndexes,
        }}
        ctx={{
          selectedHierarchyIndexes: selectedHierarchyIndexes,
          productIds: productIds,
          selectedProductIds: selectedProductIds,
          products: products
        }}
        uiState={{
          showSalesHysory: false,
          hierarchyColumnsButton: true,
          freezeColumns: freezeColumns,
          downloadButton: true,
          showFilterButton: true,
          showCustomHeading: false
        }}/>
      <PredictionsTable
        actions={{ setCheckedProducts: setCheckedProducts }}
        ctx={{
          checkedProducts: checkedProducts,
          selectedHierarchyIndexes: selectedHierarchyIndexes,
          selectedProductIds: selectedProductIds,
          products: products
        }}
        uiState={{ freezeColumns: freezeColumns }}
      />
    </div>
  );
};

ProductView.ChartCarouselToDisplayItensInfo = PlanVsForecastChartCarousel;

function PlanVsForecastChartCarousel({ ctx }) {
  const { checkedProducts, products } = ctx || {};
  const [activeIndex, setActiveIndex] = useState(0);
 
  return (
    <Carousel slideNumber={checkedProducts.length} onSlide={setActiveIndex}>
      {checkedProducts.map((id, index) => (
        <div
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
          className={`carousel-item ${index === 0 ? "active" : ""}`}
          key={id}
        >
          {index === activeIndex && (
            <ProductAnalysisChart ctx={{ productId: id, products: products }} />
          )}
        </div>
      ))}
    </Carousel>
  );
}
 

ProductView.propTypes = { actions: PropTypes.shape(), ctx: PropTypes.shape() };
PlanVsForecastChartCarousel.propTypes = { ctx: PropTypes.shape() };